import React from "react";
import {HashLink} from "react-router-hash-link";
import Hire from "../../widgets/Hire";

function Seccion1() {
    return (
        <>
            <div className="bg-[#DC4600] h-[120px]"></div>
            <section className="pt-8 max-md:px-5 relative bg-[#DC4600]" id="inicio">
                <div className="container text-center"><h1
                    className="text-[25px] md:text-[39px] font-bold leading-[1.1em] mb-6">RENOVAR Stella TV</h1>
                    <div className="max-w-[876px] mx-auto leading-[1.5em] text-white font-light">Seleccione su <strong>plan
                        de
                        Stella TV que quiere renovar</strong>, mensual, trimestral, semestral o anual. Abajo los
                        paquetes con sus promociones.
                        <HashLink   to='/#planes' className="text-active font-normal hover:underline">Comprar StellaTV
                        </HashLink> Barato
                    </div>
                </div>
            </section>
            <section className="pt-16 pb-20 max-md:px-5 bg-[#DC4600]">
                <div className="container grid md:grid-cols-4 border-2 border-white">
                    <div
                        className="flex flex-col items-center gap-5 text-center p-2.5 md:pb-6 lg:border-r-2 border-b-2 border-white">
                        <HashLink   to='/#planes' className="btn-primary px-5 py-2.5 text-[13px] max-w-max border-2 leading-none no-underline text-white"
                        >RENOVAR 1 MES</HashLink><p className="text-[13px] text-white">Mensual (Precio:
                        8.00$)</p>
                    </div>
                    <div
                        className="flex flex-col items-center gap-5 text-center p-2.5 md:pb-6 lg:border-r-2 border-b-2 border-white">
                        <HashLink  to='/#planes' className="btn-primary px-5 py-2.5 text-[13px] max-w-max border-2 leading-none no-underline text-white"
                        >RENOVAR 3 MESES</HashLink><p className="text-[13px] text-white">Trimestral
                        (Precio:
                        23.99$)</p></div>
                    <div
                        className="flex flex-col items-center gap-5 text-center p-2.5 md:pb-6 lg:border-r-2 border-b-2 border-white">
                        <HashLink  to='/#planes' className="btn-primary px-5 py-2.5 text-[13px] max-w-max border-2 leading-none no-underline text-white"
                        >RENOVAR 6 MESES</HashLink><p className="text-[13px] text-white">+1 pantalla y 1
                        Mes de
                        regalo (Precio: 48.99$)</p></div>
                    <div
                        className="flex flex-col items-center gap-5 text-center p-2.5 md:pb-6  border-white">
                        <HashLink  to='/#planes' className="btn-primary px-5 py-2.5 text-[13px] max-w-max border-2 leading-none no-underline text-white"
                        >RENOVAR 1 AÑO</HashLink><p className="text-[13px] text-white">+1 pantalla y 2
                        Mes de regalo
                        (Precio: 86.99$)</p></div>
                </div>
            </section>
            <section className="pb-[100px] max-md:px-5 bg-gradient-to-b from-[#dc4600] to-[#0c0a16]">
                <div className="container grid md:grid-cols-3 gap-8">
                    <div className="">
                        <div className="flex gap-4">
                            <div className="shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"
                                     fill="currentColor" className="w-[50px] h-[50px] text-white">
                                    <path
                                        d="M480.052 369.741c49.476-69.417 41.913-164.522-25.665-226.473-30.877-28.305-70.24-45.926-112.761-50.847a15 15 0 0 0-.833-.958C303.802 53.038 250.658 31 194.988 31 89.049 31 0 109.933 0 211c0 35.435 11.007 69.404 31.916 98.741L2.707 401.447a14.999 14.999 0 0 0 21.09 17.923l88.827-45.167c18.242 7.855 37.586 13.009 57.618 15.354C208.884 430.193 262.315 451 316.98 451c28.416 0 56.729-5.791 82.36-16.798l88.831 45.169a15 15 0 0 0 6.795 1.629c10.123 0 17.38-9.865 14.295-19.553zm-361.374-25.72a15 15 0 0 0-13.233.179l-63.267 32.17 20.66-64.866a15 15 0 0 0-2.473-13.788C40.499 272.286 29.998 242.301 29.998 211c0-82.71 74.014-150 164.99-150 36.636 0 71.905 11.099 100.514 31.086-96.348 9.688-173.51 84.942-173.51 178.914 0 29.228 7.492 57.366 21.617 82.576a173.6 173.6 0 0 1-24.931-9.555m287.845 60.178a15 15 0 0 0-13.233-.178C369.905 415.129 343.518 421 316.98 421c-90.976 0-164.99-67.29-164.99-150s74.014-150 164.99-150 164.99 67.29 164.99 150c0 31.301-10.501 61.286-30.368 86.715a15 15 0 0 0-2.473 13.788l20.66 64.866z"></path>
                                    <circle cx="255.984" cy="271" r="15"></circle>
                                    <circle cx="315.981" cy="271" r="15"></circle>
                                    <circle cx="375.977" cy="271" r="15"></circle>
                                </svg>
                            </div>
                            <div className="text-white"><h3 className="text-lg font-medium leading-[1.3em] mb-4 underline">Mandar su cuenta
                                Stella TV a renovar por Whatsapp</h3><p className="text-sm leading-[1.5em]">Luego de
                                realizar el pago de su renovación de magis tv, <strong>tiene que mandar su
                                    cuenta/usuario a este chat:</strong></p></div>
                        </div>
                        <Hire label={'MANDAR CUENTA'}/>
                    </div>
                    <div className="">
                        <div className="flex gap-4">
                            <div className="shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                                     fill="currentColor" className="w-[50px] h-[50px] text-white">
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.9 7.9 0 0 1 12 20m6.31-3.1L7.1 5.69A7.9 7.9 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9"></path>
                                </svg>
                            </div>
                            <div className="text-white"><h3 className="text-lg font-medium leading-[1.3em] mb-4 underline">Solo se pueden
                                renovar cuentas compradas con nosotros</h3><p className="text-sm leading-[1.5em]">Para
                                seguir <strong>renovando su misma</strong> cuenta debe asegurarse de <strong>comprar
                                    Stella TV desde nuestra web</strong>, de lo contrario se le brindará una cuenta y
                                contraseña nueva.</p></div>
                        </div>
                    </div>
                    <div className="">
                        <div className="flex gap-4">
                            <div className="shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                                     fill="currentColor" className="w-[50px] h-[50px] text-white">
                                    <path
                                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
                                </svg>
                            </div>
                            <div className="text-white"><h3 className="text-lg font-medium leading-[1.3em] mb-4 underline">Haga su renovación
                                antes un evento importante</h3><p className="text-sm leading-[1.5em]">Puede <strong>renovar
                                su usuario de Stella TV días antes</strong>, de ese modo no se perderá ningún evento
                                deportivo importante.</p></div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Seccion1;
